export default "__VITE_ASSET__BzrVMlXb__"